import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore/lite';
import { GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const config = {
  apiKey: "AIzaSyAJC1fKzN4xH_l-Q-6M30zXtKiBXzzPc3M",
  authDomain: "cafetefrida.firebaseapp.com",
  databaseURL: "https://cafetefrida.firebaseio.com",
  projectId: "cafetefrida",
  storageBucket: "cafetefrida.appspot.com",
  messagingSenderId: "935483694980",
  appId: "1:935483694980:web:9f88f484a0289a9f1087d1"
}

export const app = initializeApp(config);
export const db = getFirestore(app);
export const provider = new GoogleAuthProvider();
export const storage = getStorage(app);